import classNames from 'classnames/bind';
import Link from 'next/link';
import React from 'react';
import styles from './index.module.scss';

type ButtonProps = {
  href?: string;
  text?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  arrow?: boolean;
  diap?: boolean;
  outline?: boolean;
  transparent?: boolean;
  link?: boolean;
};

const Button = ({
  href,
  text,
  children,
  onClick,
  style,
  arrow,
  diap,
  outline,
  transparent,
  link,
}: ButtonProps) => {
  const cx = classNames.bind(styles)(
    'button',
    { arrow: arrow },
    { diap: diap },
    { outline: outline },
    { link: link },
    { transparent: transparent },
  );

  if (href)
    return (
      <Link href={href} className={cx} style={style} onClick={onClick}>
        <span>{children || text}</span>
      </Link>
    );

  if (!href)
    return (
      <span
        className={cx}
        style={style as React.CSSProperties}
        onClick={onClick}
      >
        <span>{children || text}</span>
      </span>
    );

  return null;
};

export default Button;
